import { api } from '@/services';

export interface XmlDaNotaFiltro {
  ChaveAcessoDOC: string;
}

/** O XML da nota como o acervo do e-Malote o guarda, e o nome do arquivo (a chave de acesso). */
export interface XmlDaNota {
  NomeArquivo: string;
  Xml: string;
}

export interface XmlDaNotaResponse {
  status: { resultado: boolean; mensagem: string };
  data: XmlDaNota | null;
}

/**
 * O XML da nota para o botão "Baixar XML" do detalhe (SPEC-018, §3, item 5). O servidor confere que a nota é do gestor
 * logado antes de ler o acervo; a tela manda só a chave, nunca bucket nem caminho.
 */
export function fetchXmlDaNota(filtro: XmlDaNotaFiltro) {
  return api.post<XmlDaNotaResponse, XmlDaNotaFiltro>(
    'TurboPro/DocumentosFiscais/XmlDaNota',
    filtro
  );
}
